/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';

// style imports
import './Reports.scss';

/**
 * this page is used to show reports in table
 * 
 * @param props
 * 
 * @return html to render reports list
 * 
**/

export class Reports extends Component {

    render () {
        return (
            <h4 style={{margin:"auto"}}><b>This page is under construction</b></h4>
        );
    }
}